import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';

import { getMainEvent } from '../../checkout/selectors/event'
import {
  getTitle,
  getTime,
  getTimezone,
  getLocation,
  getSeparatedDate,
  getSeparatedLocation,
} from '@checkout-h/listingBannerHelpers';
import Translation from '@checkout-s/Translation';
import { selectIsHeroLayout } from '@checkout-b/checkout/selectors/ui';
import { isDynamicListing } from '@checkout-b/checkout/selectors/dynamic-listing';

const PageContent = ({ children, withPageWrapper }) => {
  if (withPageWrapper) {
    return (
      <div className="page-content__outer">
        <div className="page-content__inner">{children}</div>
      </div>
    );
  }

  return children;
}

class ListingEventDetails extends Component {

    getTimeFromProps = () => {
      return getTime(
        this.props.uiConfig,
        this.props.isRecurring,
        this.props.start,
        this.props.end,
        this.props.locale
      );
    }

    getTimezoneFromProps = () => {
      return getTimezone(this.props.uiConfig, this.props.timezone);
    }

    getLocationFromProps = () => {
      return getLocation(
        this.props.uiConfig,
        this.props.venueName,
        this.props.venueAddress
      );
    }

    render() {
        const separatedDate = getSeparatedDate(
          this.props.uiConfig,
          this.props.isRecurring,
          this.props.start,
          this.props.end,
          this.props.locale
        );
        const hasSeparatedDate = separatedDate.date || separatedDate.time;

        const separateLocation = getSeparatedLocation(
          this.props.uiConfig,
          this.props.venueName,
          this.props.venueAddress
        );
        const hasSeparatedLocation = separateLocation.venueName || separateLocation.venueAddress;

        const hasLocation = (!this.props.isHeroLayout && !this.props.isDynamicListing) || separateLocation.venueName || separateLocation.venueAddress;
        const hasDate = (!this.props.isHeroLayout && !this.props.isDynamicListing) || separatedDate.date || separatedDate.time;

        const title = getTitle(this.props.name, this.props.uiConfig);

        return(
          <PageContent withPageWrapper={this.props?.withPageWrapper}>
            <div className="banner__event-details">
              <h1 className="listing__title" style={{ display: title?.trim() ? 'block' : 'none' }}>
                {title}
              </h1>

              {(!this.props.hideAgeLimit && this.props.ages.trim()) && (
                <div className="event-details__ages">
                  <i className="icon-user" aria-hidden="true"></i>
                  <Translation>{this.props.ages}</Translation>
                </div>
              )}

              <div className="event-details">
                {hasDate && (
                  <div className="event-details__date">
                    <div className="event-details__date__icon">
                      <i className="icon-calendar_today" aria-hidden="true"></i>
                    </div>
                    {(!this.props.isHeroLayout && !this.props.isDynamicListing) && <span className="event-details__date-1">{this.getTimeFromProps()} {this.getTimezoneFromProps()}</span>}

                    {(this.props.isHeroLayout || this.props.isDynamicListing) && hasSeparatedDate && (
                      <div className="event-details__date-group">
                        {separatedDate.date && (<span className="event-details__date-1">{separatedDate.date} {!separatedDate.time && this.getTimezoneFromProps()}</span>)}
                        {separatedDate.time && (<span className="event-details__date-2">{separatedDate.time} {this.getTimezoneFromProps()}</span>)}
                      </div>
                    )}
                  </div>
                )}

                {hasLocation && (
                  <div className="event-details__location">
                    <div className="event-details__location__icon">
                      <i className="icon-room" aria-hidden="true"></i>
                    </div>
                    <address>
                      {(!this.props.isHeroLayout && !this.props.isDynamicListing) && (<><span className="event-details__location-name">{this.getLocationFromProps()}</span><br /></>)}
                      {(this.props.isHeroLayout || this.props.isDynamicListing) && (
                        <Fragment>
                          {!hasSeparatedLocation && (<span className="event-details__location-name">{this.getLocationFromProps()}</span>)}
                          {hasSeparatedLocation && (
                            <Fragment>
                              {separateLocation.venueName && <span className="event-details__location-name-1">{separateLocation.venueName}</span>}
                              {separateLocation.venueAddress && <span className="event-details__location-name-2">{separateLocation.venueAddress}</span>}
                            </Fragment>
                          )}
                        </Fragment>
                      )}
                    </address>
                  </div>
                )}
              </div>
            </div>
          </PageContent>
        )
    }

    renderTicketsButton = () => {
        return this.props.children;
    }
}

const mapStateToProps = (state, props) => {

    const venue = state.venue.venues ? Object.values(state.venue.venues)[0] : null;
    const mainEvent = getMainEvent(state);
    const theEvent = mainEvent?.event ?? {};
    return {
        locale: state.intl.locale,
        end: mainEvent?.event?.end ?? '',
        name: mainEvent?.event?.name ?? '',
        start: mainEvent?.event?.start ?? '',
        venueName: venue ? venue.name : "",
        venueAddress: venue ? venue.address.city + ', ' + venue.address.region : "",
        ages: mainEvent?.event?.age_minimum ?? '',
        hideAgeLimit: mainEvent?.event?.hide_age_limit,
        uiConfig: state.ui.uiConfig,
        isRecurring: !!mainEvent?.event?.isRecurring,
        timezone: mainEvent?.event?.timezone,
        isHeroLayout: selectIsHeroLayout(state),
        isDynamicListing: isDynamicListing(state),
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({}, dispatch);
}

ListingEventDetails.propTypes = {
    locale: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    start: PropTypes.string.isRequired,
    end: PropTypes.string,
    venueName: PropTypes.string.isRequired,
    venueAddress: PropTypes.string.isRequired,
    isRecurring: PropTypes.bool,
    timezone: PropTypes.string
}

export default connect(mapStateToProps, mapDispatchToProps)(ListingEventDetails)
